<template>
    <b-container fluid class="p-3 h-100">
        <b-row class="no-gutters mb-4 h-100">
            <grid ref="grid" class="w-100 h-100" :fetchCallback="fetchCallback" :columnDefs="columnDefs" :isSearch="false">
                <b-button variant="default" @click="clearLogs">Clear Logs</b-button>
            </grid>
        </b-row>
    </b-container>
</template>

<script>

import { mapGetters } from 'vuex';
import Grid from '../generic/grid/grid.vue';
import api from '../../api';
import { QUICKBOOKS_ENDPOINT_OLD } from '../../endpoints';
export default {
    name: 'AccountChart',
    components: {
        Grid
    },
    data() {
        return {
            rowData: [],
            offset: 0,
            limit: 20,
            sort: 'id',
            desc: false,
        };
    },
    computed: {
        ...mapGetters('quickbooksOld', ['accountMapping', 'accountChoices']),
        columnDefs() {
            return [
                {
                    field: 'timestamp',
                    headerName: 'Timestamp',
                    cellRenderer: ({ data }) => data.row.split('-')[0]
                },
                {
                    field: 'row',
                    headerName: 'Log',
                    cellRenderer: ({ data }) => data.row.split('-').slice(1).join('-')
                },
            ]
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return api.get(QUICKBOOKS_ENDPOINT_OLD() + 'error-logs/', {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        }
    },
    methods: {
        async clearLogs() {
            try {
                this.$parent.$emit('busy', true)
                await api.post(QUICKBOOKS_ENDPOINT_OLD() + 'clear-logs/', {
                    component: 'ERROR'
                })
                this.$refs.grid.refreshDataSource()
            } catch (e) {
                this.errorToast({ text: 'Could not clear logs' })
            } finally {
                this.$parent.$emit('busy', false)
            }
        }
    },
    mounted() {
        this.fetchData()
    },
}

</script>

<style scoped>
/* Your component styles here */
</style>
